module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kgw5i"))).then(() => parcelRequire('1iHdE'));